import { Component, Inject, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { eEstadoAccionHipo, ParametrosMaestro } from 'src/app/models/common/enumModel';
import { HipoAccionModel } from 'src/app/models/hipo/HipoAccionModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';

@Component({
  templateUrl: './hipos-accion-registrar-dialog.component.html',
  styleUrls: ['./hipos-accion-registrar-dialog.component.css']
})
export class HiposAccionRegistrarDialogComponent implements OnInit {
  listaEstados!: ParametroModel[];
  constructor(
    public dialogRef: MatDialogRef<HiposAccionRegistrarDialogComponent>,
    private alertDialogService: AlertDialogService,
    private parametroService: ParametroService,
    @Inject(MAT_DIALOG_DATA) public data: HipoAccionModel) { }

  ngOnInit(): void {
    this.parametroService
      .getDetalles(ParametrosMaestro.ESTADOS_ACCION_HIPO)
      .subscribe((p) => {
        this.listaEstados = p.items;
      });
  }

  
  onNoClick(): void {
    this.dialogRef.close();
  }

  EsValido(): boolean {
    return this.data.detalle !== '' && this.data.fechaLimite != null;
  }

  onSaveClick(): void {
    if(this.data.idEstado == eEstadoAccionHipo.Cerrado && !this.data.fechaCierre){
      
        this.alertDialogService.open("Seleccione la fecha de cierre");
    }
    else{
      let estadoSelect = this.listaEstados.find(
        (p) => p.idParametroDetalle == this.data.idEstado
      );
      if(estadoSelect){
        this.data.estado=estadoSelect.nombre
      }
      this.dialogRef.close(this.data);
    }
  }

}
